import React from "react";
import { Modal } from "antd";
import styles from "assets/css/modals.module.css";
import { inject, observer } from "mobx-react";
import VideoTrimerForm from "../Forms/VideoTrimerForm";

const VideoTrimmerModal = props => {
  const { modalStore } = props;

  return (
    <>
      <Modal
        title={
          <div className="text-center">
            <h4 className="pt-3 fw-bold">Clip trimming</h4>
          </div>
        }
        closeIcon={
          <div className={`btn ${styles.modalCloseBtn}`}>
            <i className="fas fa-times"></i>
          </div>
        }
        visible={modalStore.showVideoTrimmerModal}
        onCancel={() => modalStore.toggleModal("showVideoTrimmerModal", false)}
        width={722}
        footer={null}
        centered
        maskStyle={{
          background: "linear-gradient(135deg, #00000080, #107c9885)"
        }}
      >
        <div className="px-5">
          <VideoTrimerForm />
        </div>
      </Modal>
    </>
  );
};

export default inject(stores => ({
  modalStore: stores.store.modalStore
}))(observer(VideoTrimmerModal));
